<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only>
            <slot name="read_only">
                <input v-if="!!value" type="text" :value="value" :disabled="true">
            </slot>
        </template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <div v-if="editable" :class="{'uk-active': other_value!==false}" class="lam-select-combo">
            <select
                v-if="!hide_select"
                ref="menu"
                :id="identifier"
                :name="name"
                :disabled="disabled"
                :class="{ [`uk-width-${width}`]: true, [`uk-form-${size}`]: true }"
                class="form-select"
                @change="pick"
            >
                <option
                    v-if="!!emptyLabel"
                    :value="emptyValue"
                    :selected="value === emptyValue"
                    :disabled="!!required"
                >
                    {{ emptyLabel }}
                </option>
                <option
                    v-for="option in options"
                    :key="option_value(option)"
                    :value="option_value(option)"
                    :selected="is_picked(option)"
                >
                    {{ option[labelField] || option }}
                </option>
            </select><!--
            //--><div class="uk-width-1-1 lam-in-field-button">
                <input
                    type="text"
                    ref="additional_value"
                    v-model="other_value"
                    placeholder="Type in a new value"
                    class="uk-width-1-1"
                />
                <a href="#" class="uk-icon-remove" title="Cancel and go back to the drop down menu" @click.prevent.stop="add_cancel"></a>
                <a href="#" class="uk-icon-check" title="Save the new value" @click.prevent.stop="add_value"></a>
            </div>
        </div>
    </form-group>
</template>

<script type="text/javascript">
import is_nibnut_component from "../mixins/IsNibnutComponent"

import FormGroup from "./FormGroup"

const other = "Other..."

export default {
    mixins: [is_nibnut_component],
    components: {
        FormGroup
    },
    watch: {
        shown: "load",
        contextData: "load"
    },
    mounted () {
        this.load()
    },
    methods: {
        load () {
            if(this.shown) {
                this.$store.dispatch(
                    "AUTOSUGGEST",
                    {
                        query: this.contextData,
                        context: this.name
                    }
                ).then(records => {
                    this.options = records || []
                    this.object_mode = !!this.options.length && !!this.options[0][this.idField]
                    if(this.object_mode) {
                        if((this.value !== this.emptyValue) && !this.options.find(option => option[this.idField] === this.value)) this.options.unshift({ [this.idField]: this.value || this.emptyValue, [this.labelField]: this.value || "(Select a value)" })
                        this.options.push({ [this.idField]: other, [this.labelField]: other })
                    } else {
                        if((this.value !== this.emptyValue) && (this.options.indexOf(this.value) < 0)) this.options.unshift(this.value || "(Select a value)")
                        this.options.push(other)
                    }
                })
            }
        },
        option_value (option) {
            if(this.object_mode) return option[this.idField]
            return option
        },
        is_picked (option) {
            return this.value === this.option_value(option)
        },
        pick (event) {
            if(this.editable) {
                if(
                    (this.object_mode && (event.target.value === "")) ||
                    (event.target.value === other)
                ) {
                    this.other_value = this.object_mode ? "" : this.value
                    this.hide_select = true
                    this.$nextTick(() => {
                        this.$refs.additional_value.select()
                    })
                } else this.$emit("input", event.target.value, this.name)
            }
        },
        add_cancel () {
            // This happens *after* the field's blur or change events...
            this.other_value = false
            this.hide_select = false
        },
        add_value () {
            setTimeout(() => {
                if(this.other_value !== false) {
                    const wrap_it_up = (value) => {
                        if(this.changedValue) this.changedValue({ target: { name: this.name } }, value, this.value)
                        else this.$emit("input", value, this.name)
                        this.options.splice(this.options.length - 1, 0, value)
                        this.add_cancel()
                    }
                    if(this.object_mode) {
                        this.$store.dispatch(
                            "AUTOSUGGEST_ADD",
                            {
                                context: this.name,
                                data: {
                                    ...this.contextData,
                                    name: this.other_value
                                }
                            }
                        ).then(option => {
                            if(option) wrap_it_up(this.object_mode ? option : option.id)
                        }).catch(error => {
                            this.$error(error.message)
                        })
                    } else wrap_it_up(this.other_value)
                }
            }, 125)
        }
    },
    computed: {
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: null
        },
        contextData: {
            type: Object,
            default () {
                return {}
            }
        },
        emptyValue: {
            default: 0
        },
        emptyLabel: {
            type: String,
            default: ""
        },
        idField: {
            type: String,
            default: "id"
        },
        labelField: {
            type: String,
            default: "name"
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        placeholder: {
            type: String,
            default: ""
        },
        required: {
            type: Boolean,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        },
        shown: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            object_mode: false,
            other_value: false,
            options: [],
            hide_select: false
        }
    }
}
</script>
